module.exports = __webpack_public_path__ + "static/media/hail-damaged-car.8f747268.png";